import MouseEventArgs, { MouseButton } from './MouseEventArgs';
import Tool from './Tool';
import NodeLayer from './NodeLayer';
import Rect from './Rect';
import Editor from './Editor';
import { createTransformToolChain } from './toolChains';
import Vector2 from './Vector2';
import { v4 as uuidv4 } from 'uuid';

export default class NewNodeTool extends Tool {
  public constructor(editor: Editor) {
    super(editor, 'new_node');
  }

  public handleMouseDown(arg: MouseEventArgs): boolean {
    if (arg.button != MouseButton.Left) {
      return false;
    }

    var pos = arg.worldPosition;

    var layer = new NodeLayer(this.editor, uuidv4(), new Rect(pos));
    this.editor.setSelectedLayer(layer);
    this.editor.rootLayerGroup.addLayer(layer);

    if (this.editor.rootLayerGroup.layers.length == 1) {
      this.editor.setStartLayer(layer);
    }

    return false;
  }

  public handleMouseMove(arg: MouseEventArgs): boolean {
    return false;
  }

  public handleMouseUp(arg: MouseEventArgs): boolean {
    var selected = this.editor.selectedLayer;

    if (selected != null) {
      var size = selected.boundingRect.size;

      var minSize = new Vector2(Math.max(size.x, 100), Math.max(size.y, 100));

      selected.setBoundingRect(
        new Rect(selected.boundingRect.position, minSize)
      );
    }

    this.editor.setCurrentTool(createTransformToolChain(this.editor));
    return false;
  }
}
